import { Component, OnInit } from '@angular/core';
import { AccountHttpService } from './generated/account-http.service';
import { getBrowserLang, setBrowserLang, proposedLanguages } from './helpers';
import { AuthService } from './shared/auth.service';
import { SharedService } from './shared/service';

@Component({
  selector: 'app-layout',
  templateUrl: './app.layout.html'
})
export class AppLayout implements OnInit {

  private _lang: string;

  async ngOnInit() {
    this._lang = getBrowserLang();
    const p = new Set<string>(proposedLanguages);
    if (this._lang != null) {
      p.add(this._lang);
    }
    this.proposedLanguages = Array.from(p);
    await this.shared.loadRessources(this._lang);
  }

  proposedLanguages: string[];

  get lang() {
    return this._lang;
  }

  set lang(value: string) {
    this._lang = value;
    setBrowserLang(this._lang);
    this.shared.loadRessources(this._lang);
  }

  constructor(private accountHttpService: AccountHttpService, private authService: AuthService, public shared: SharedService) {

  }

  get authInfoBehavior() {
    return this.authService.authInfoBehavior;
  }

  async logOut() {
    await this.accountHttpService.logOut().toPromise();
    this.authService.logOut();
  }
}
